import type { DocumentType } from "../DocumentTypes";

const NON_SELECTABLE_METADOC_DOCUMENT_TYPES = new Set([
  "AI_ALLOCATOR_NOTES",
  "AI_SORTED_AND_CLASSIFIED_DOCUMENTS",
]);

export const isSelectableForMetadoc = (document: DocumentType): boolean => {
  const isPdfDocument = document.extension?.toLowerCase() === ".pdf";
  const isBlockedType = NON_SELECTABLE_METADOC_DOCUMENT_TYPES.has(
    document.type,
  );

  return isPdfDocument && !isBlockedType;
};

export const getSelectableMetadocDocumentIds = (
  documents: DocumentType[],
): Set<number> =>
  new Set(
    documents
      .filter((document) => isSelectableForMetadoc(document))
      .map((document) => document.id),
  );

type SanitizeMetadocSelectedRowsArgs = {
  nextSelectedRows: Set<string | number>;
  currentSelectedRows: ReadonlySet<string | number>;
  documents: DocumentType[];
  metaDoc: boolean;
};

export const sanitizeMetadocSelectedRows = ({
  nextSelectedRows,
  currentSelectedRows,
  documents,
  metaDoc,
}: SanitizeMetadocSelectedRowsArgs): Set<string | number> => {
  if (!metaDoc) {
    return nextSelectedRows;
  }

  const selectableMetadocDocumentIds =
    getSelectableMetadocDocumentIds(documents);
  const nextIds = new Set(Array.from(nextSelectedRows).map((id) => Number(id)));
  const currentIds = new Set(Array.from(currentSelectedRows).map(Number));
  const isHeaderSelectAllAttempt =
    nextIds.size === documents.length &&
    documents.length > selectableMetadocDocumentIds.size;

  if (isHeaderSelectAllAttempt) {
    const allEligibleAlreadySelected =
      selectableMetadocDocumentIds.size > 0 &&
      Array.from(selectableMetadocDocumentIds).every((id) =>
        currentIds.has(id),
      );

    if (allEligibleAlreadySelected) {
      return new Set();
    }

    return new Set(selectableMetadocDocumentIds);
  }

  return new Set(
    Array.from(nextIds).filter((id) => selectableMetadocDocumentIds.has(id)),
  );
};
